import moment from "moment";
import { CargoActionTimesInput } from "__generated__/graphql";
import type { CargoActionsFromQuery } from "./BulkPlanning";

export const toCargoActionTimesInput = (action: CargoActionsFromQuery): CargoActionTimesInput => ({
	id: action.id,
	date: !action.displayAsWindow ? moment(action.start).format("YYYY-MM-DD") : undefined,
	windowFrom: action.displayAsWindow ? action.start : undefined,
	windowTo: action.displayAsWindow ? action.end : undefined,
});
